import {useEffect} from 'react';
import {showGeneralError} from '@/helper';
import {IUseHandleGeneralErrors} from '@/api/interfaces';

const useHandleGeneralErrors = ({error = null, message = null}: IUseHandleGeneralErrors) => {
    useEffect(() => {
        !!error && showGeneralError({error, message});
    }, [error, message]);
};

export default useHandleGeneralErrors;
